import type { ReactNode } from 'react';
import { deduplicateMainProductsExtension } from './deduplicateMainProducts';
import { exportFinalNomenclatureExtension } from './exportFinalNomenclature';

export type OperationExtension = {
    renderParameterEditor?: (props: {
        editParams: string;
        onEditParamsChange: (value: string) => void;
    }) => ReactNode;
    renderReport?: (report: unknown) => ReactNode | null;
};

const extensions: Record<string, OperationExtension> = {
    [deduplicateMainProductsExtension.code]: deduplicateMainProductsExtension,
    [exportFinalNomenclatureExtension.code]: exportFinalNomenclatureExtension
};

export const getOperationExtension = (operationCode?: string | null): OperationExtension | undefined => {
    if (!operationCode) return undefined;
    return extensions[operationCode];
};
